import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login_service_auth } from "../../services/authentication";
import { useDispatch, useSelector } from "react-redux";
import { asyncStatus } from "../../utils/asyncStatus";

const Login = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();


  const { login_status } = useSelector((state) => state.userAuth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  
  const handleLogin = () => {
    const obj = {
      email: email,
      password: password,
    };
    dispatch(login_service_auth(obj));


  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-center text-gray-700">Login</h2>
        <div className="mt-4">
          <label className="block text-gray-600">Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
            className="w-full mt-2 p-3 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
          />
        </div>
        <div className="mt-4">
          <label className="block text-gray-600">Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            className="w-full mt-2 p-3 border rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
          />
        </div>
        <button
          onClick={handleLogin}
          className="w-full mt-6 bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-3 rounded-lg flex justify-center items-center transition duration-300"
          disabled={login_status === asyncStatus.LOADING}
        >
          {login_status === asyncStatus.LOADING ? (
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-white"></div>
          ) : (
            "Login"
          )}
        </button>
      </div>
    </div>
  );
};

export default Login;
